var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c(
          "b-container",
          { attrs: { fluid: "" } },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  { staticClass: "showLargeScreenOnly", attrs: { md: "3" } },
                  [
                    _c(
                      "f7-button",
                      {
                        staticClass: "button-action milkyBlockBlack",
                        attrs: { md: "3" },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("f7-icon", { attrs: { f7: "refresh" } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "fab-label" }, [
                          _vm._v(_vm._s(_vm.$t("common.rfrsh"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "3" } },
                  [
                    _c(
                      "f7-button",
                      {
                        staticClass: "button-action milkyBlockBlack",
                        attrs: { md: "3", disabled: !_vm.canAddAccount() },
                        on: { click: _vm.addAccount },
                      },
                      [
                        _c("f7-icon", { attrs: { f7: "add" } }),
                        _vm._v(" "),
                        _vm.currentType === "1"
                          ? _c("span", { staticClass: "fab-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("administration.company_add"))
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentType === "2"
                          ? _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("administration.user_add"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("b-row", [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  { staticClass: "adminUsersCompaniesListHeader" },
                  [
                    _c(
                      "f7-grid",
                      { attrs: { "no-gutter": "" } },
                      [
                        _c(
                          "f7-col",
                          {
                            staticClass: "pilotageTabController",
                            attrs: { width: "50" },
                          },
                          [
                            _c(
                              "f7-link",
                              {
                                staticClass:
                                  "pilotageLink border-top-left-radius-10px",
                                class: {
                                  tabActive: _vm.currentType === "2",
                                  tabUnactive: _vm.currentType !== "2",
                                },
                                attrs: { "tab-link": ".usersTab", active: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeCurrentType("2")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("administration.users_list")
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "f7-col",
                          {
                            staticClass: "pilotageTabController",
                            attrs: { width: "50" },
                          },
                          [
                            _c(
                              "f7-link",
                              {
                                staticClass:
                                  "pilotageLink border-top-left-radius-10px",
                                class: {
                                  tabActive: _vm.currentType === "1",
                                  tabUnactive: _vm.currentType !== "1",
                                },
                                attrs: { "tab-link": ".companiesTab" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeCurrentType("1")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("administration.companies_list")
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "f7-tabs",
                      [
                        _c(
                          "f7-tab",
                          { staticClass: "usersTab", attrs: { active: "" } },
                          [
                            _c("f7-searchbar", {
                              staticClass: "webdatalist",
                              attrs: {
                                "cancel-link": _vm.$t("common.cncl"),
                                placeholder: "Search in Users",
                                "search-list": "#users-list",
                              },
                              on: {
                                "searchbar:search": _vm.onUsersSearch,
                                "searchbar:clear": _vm.onUsersClear,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "itemList" },
                              [
                                _vm.usersList.length === 0
                                  ? _c("spinner")
                                  : _c("users-list", {
                                      attrs: { users: _vm.usersList },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "f7-tab",
                          { staticClass: "companiesTab" },
                          [
                            _c("f7-searchbar", {
                              staticClass: "webdatalist",
                              attrs: {
                                "cancel-link": _vm.$t("common.cncl"),
                                placeholder: "Search in Companies",
                                "search-list": "#companies-list",
                              },
                              on: {
                                "searchbar:search": _vm.onCompaniesSearch,
                                "searchbar:clear": _vm.onCompaniesClear,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "itemList" },
                              [
                                _vm.companiesList.length === 0
                                  ? _c("spinner")
                                  : _c("companies-list", {
                                      attrs: { companies: _vm.companiesList },
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbarPageBottomBlank" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }